import React from 'react';
import PropTypes from 'prop-types';

const Iconimg = (props:any)=><img {...props} src={`../../../png/${props.icon}`} />

Iconimg.propTypes = {
    icon: PropTypes.string,
  };

export default Iconimg